export enum BusinessCompanyThingValue {
  NEW = 'NEW',
  CURRENT = 'CURRENT',
  REPLACEMENT = 'REPLACEMENT',
}

export const getBusinessCompanyThingValueLabel = (
  value: BusinessCompanyThingValue
) => {
  switch (value) {
    case BusinessCompanyThingValue.NEW:
      return $localize`Valeur à neuf`;
    case BusinessCompanyThingValue.CURRENT:
      return $localize`Valeur actuelle`;
    case BusinessCompanyThingValue.REPLACEMENT:
      return $localize`Valeur de remplacement`;
    default:
      return '';
  }
};
